/* global angular */
( function () {
	'use strict';

	function ManageShareModalCtrl ( manageShareService, logger, $modalInstance, templateModel, $filter, TOOLTIP_MESSAGES, ERROR_MSGS, Session ) {
		var self      = this;
		var orderBy   = $filter( 'orderBy' );
		var searchBy  = $filter( 'filter' );

		self.template  = templateModel;
		self.fetching  = true;
		self.focusItem = [];

		self.tooltipMessages = TOOLTIP_MESSAGES;

		function cancelModal () {
			$modalInstance.dismiss( 'cancel' );
		}

		function getItem ( collection, parentName, parentKey, childName, childKey ) {
			function filterResult ( item ) {
				return item[ parentKey ] === parentName;
			}

			var arr = collection.filter( filterResult )[ 0 ];

			return orderBy( ( arr || [] )[ childKey ], childName );
		}

		function openSchool ( index, name, priv ) {
			self.schoolName = name;
			self.schoolPriv = priv;
			self.focusItem  = getItem( self.focusItem, name, 'SchoolName', 'FirstName', 'Users' ) || self.focusItem;
			self.toggleView = 'user';
		}

		function openDistrict ( index, name, priv ) {
			self.districtIndex = index;
			self.districtName  = name;
			self.districtPriv  = priv;
			self.focusItem     = getItem( self.district, name, 'District', 'SchoolName', 'Schools' );
			self.toggleView    = 'school';
		}

		function resetView () {
			self.toggleView = 'district';
			self.searchText = '';
			self.fetching   = false;
		}

		function searchCollection ( userInput ) {
			if ( userInput !== '' ) {
				self.searchItems = searchBy( self.flatList, { 'title' : userInput } );
				self.toggleView = 'search';
			} else {
				self.toggleView = 'district';
			}
		}

		function addToList ( title, id, type, path, privs ) {
			self.flatList.push( {
				'title' : title,
				'id'    : id,
				'type'  : type,
				'path'  : path,
				'privs' : privs
			} );
		}

		function processSchools ( location, school ) {
			addToList( school.SchoolName, school.ID, 'school', location.District );

			( school.Users || [] ).map( function ( user ) {
				addToList( user.FirstName + ' ' + user.LastName, user.PersonnelId, 'user', location.District + ' / ' + school.SchoolName );
			} );
		}

		function processDistricts ( location ) {
			addToList( location.District, location.ID, 'district', '' );

			( location.Schools || [] ).map( function ( school ) {
				processSchools( location, school );
			} );
		}

		function produceSearchList ( locations ) {
			self.flatList = [];
			angular.copy( locations ).map( processDistricts );
		}

		function filterLoggedInUser ( user ) {
			return user.PersonnelId === Session.getCredentials().PersonnelId;
		}

		function getLoggedInUser ( safeUser ) {
			return safeUser.filter( filterLoggedInUser )[ 0 ] || {};
		}

		function spliceLoggedInUser ( safeUser ) {
			if ( safeUser.indexOf( getLoggedInUser( safeUser ) ) > 0 ) {
				safeUser.splice( safeUser.indexOf( getLoggedInUser( safeUser ) ), 1 );
			}
		}

		function lookForLoggedInUser ( school ) {
			spliceLoggedInUser( school.Users || [] );
		}

		function lookForLoggedInSchool ( districts ) {
			( districts.Schools || [] ).map( lookForLoggedInUser );
		}

		function removeLoggedInUser ( locations ) {
			locations.map( lookForLoggedInSchool );
		}

		function processModalData ( locations ) {
			removeLoggedInUser( [ locations ] );

			self.toggleView = 'district';
			produceSearchList( [ locations ] );
			self.district = orderBy( [ locations ], 'District' );
			self.fetching = false;
		}

		function fetchLoggedInUserPriv ( locations ) {
			manageShareService.getPrivilege( self.template.id, 'users', Session.getCredentials().PersonnelId, true )
				.then( function ( priv ) {
					self.loggedUser = {
						'privs' : priv
					};

					processModalData( locations );
				} );
		}

		function stopLoadingIndicator ( msg ) {
			self.displayMessage  = true;
			self.fetching        = false;
			self.errorDisplayMsg = msg;
		}

		function showUnableToFetchLocationDisplay () {
			stopLoadingIndicator( ERROR_MSGS.manageShareFetchingError );
		}

		function activate () {
			logger.info( 'Activated Manage Share Modal View' );
			manageShareService.getLocation().then( fetchLoggedInUserPriv, showUnableToFetchLocationDisplay );
		}

		activate();

		self.cancelModal      = cancelModal;
		self.openDistrict     = openDistrict;
		self.openSchool       = openSchool;
		self.resetView        = resetView;
		self.searchCollection = searchCollection;
	}

	angular
		.module( 'app.templates' )
		.controller( 'ManageShareModalCtrl', ManageShareModalCtrl );

	ManageShareModalCtrl.$inject = [ 'manageShareService', 'logger', '$modalInstance', 'templateModel', '$filter', 'TOOLTIP_MESSAGES', 'ERROR_MSGS', 'Session' ];
} )( );
